<script setup lang="ts">
import {useConfirm} from "primevue/useconfirm";
import {Button} from "../Library";

const confirm = useConfirm();
const props = withDefaults(
    defineProps<{
        header?: String;
        message?: String;
    }>(),
    {
        header: "Are you sure?",
        message: "Clear the form and start over?",
    },
);
const emit = defineEmits(["reset"]);
const reset = (event) => {
    confirm.require({
        group: undefined,
        header: props.header,
        message: props.message,
        acceptLabel: "Yes",
        rejectLabel: "No",
        acceptClass: "grow text-white font-bold bg-red-600 px-3 py-1.5 rounded-md focus:ring-red-400",
        rejectClass: "grow px-3 py-1.5 border rounded-md",
        accept: () => {
            emit("reset");
        },
    });
};
</script>
<template>
    <Button
        @click="reset"
        class="text--white ml-auto h-7 w-7 border bg-stone-50 shadow-sm transition hover:bg-red-600 hover:text-white focus:ring-red-300 active:bg-red-600 active:text-white dark:border-stone-700 dark:bg-stone-900"
        icon="mdi:refresh"
        rounded
    />
</template>
<style scoped></style>
